<template>
  <div>
    <v-card>
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text">
          Pianificazione Manutenzione
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- Bottone di invio modifiche dello stato commessa -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="openformDialog"
              v-on="on"
              v-bind="attrs"
              small
              class="mr-5"
            >
              <v-icon color="primary">mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Crea Pianificazione</span>
        </v-tooltip>

        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="activateFilters"
              class="mr-4"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="purple"> mdi-filter </v-icon>
            </v-btn>
          </template>
          <span>{{
            this.show_filtri == false ? "Show filters" : "Hide filters"
          }}</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small @click="goBack" v-bind="attrs" v-on="on">
              <v-icon color="error"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Back</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text id="mainCardText" class="mt-3">
        <v-row align="center" justify="center" v-if="show_filtri">
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="codice"
              item-value="codice"
              label="Codice"
              style="display: inline-block; max-width: 350px"
              v-model="codice_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    codice_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    codice_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="des_tipo"
              item-value="des_tipo"
              label="Tipo"
              style="display: inline-block; max-width: 350px"
              v-model="tipo_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    tipo_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    tipo_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="des_sub_tipo"
              item-value="des_sub_tipo"
              label="Sub Tipo"
              style="display: inline-block; max-width: 350px"
              v-model="sub_tipo_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    sub_tipo_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    sub_tipo_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="des_oggetto"
              item-value="des_oggetto"
              label="Oggetto"
              style="display: inline-block; max-width: 350px"
              v-model="oggetto_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    oggetto_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    oggetto_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="des_tipo_manu"
              item-value="des_tipo_manu"
              label="Tipo Manu."
              style="display: inline-block; max-width: 350px"
              v-model="tipo_manu_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    tipo_manu_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    tipo_manu_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="des_condizione"
              item-value="des_condizione"
              label="Condizione"
              style="display: inline-block; max-width: 350px"
              v-model="condizione_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    condizione_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    condizione_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="applica_intero_famiglia"
              item-value="applica_intero_famiglia"
              label="Intero Famiglia"
              style="display: inline-block; max-width: 350px"
              v-model="famiglia_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    famiglia_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    famiglia_search === "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="applica_intero_sottofamiglia"
              item-value="applica_intero_sottofamiglia"
              label="Intero  Sottofamiglia"
              style="display: inline-block; max-width: 350px"
              v-model="sottofamiglia_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    sottofamiglia_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    sottofamiglia_search === ""
                      ? "mdi-filter"
                      : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table
        :loading="loading"
        :items="lista_tabella"
        :headers="headers_etichette"
      >
        <!-- Botton for updating Intervento -->
        <template v-slot:[`item.edit`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="updatePianificazione(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Modifica </span>
          </v-tooltip>
        </template>
          <template v-slot:[`item.des_tipo_manu`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                v-show="item.id_tipo_manutenzione == 33360"
                color="primary"
              >
                mdi-wrench-clock
              </v-icon>
            </template>
            <span>{{ item.des_tipo_manu }} </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                v-show="item.id_tipo_manutenzione == 33363"
                color="orange"
              >
                mdi-account-wrench-outline
              </v-icon>
            </template>
            <span>{{ item.des_tipo_manu }} </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                v-show="item.id_tipo_manutenzione == 33362"
                color="green"
              >
                mdi-magic-staff
              </v-icon>
            </template>
            <span>{{ item.des_tipo_manu }} </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                v-show="item.id_tipo_manutenzione == 33361"
                color="red"
                >mdi-fire</v-icon
              >
            </template>
            <span>{{ item.des_tipo_manu }} </span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.applica_intero_famiglia`]="{ item }">
          <v-icon v-if="item.applica_intero_famiglia === 'si'"
            >mdi-checkbox-outline</v-icon
          >
          <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
        </template>
        <template v-slot:[`item.applica_intero_sottofamiglia`]="{ item }">
          <v-icon v-if="item.applica_intero_sottofamiglia === 'si'"
            >mdi-checkbox-outline</v-icon
          >
          <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
        </template>

        <!-- Botton for deleting the Intervento -->
        <template v-slot:[`item.delete`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="deletePianificazione(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-window-close </v-icon>
              </v-btn>
            </template>
            <span>Elimina</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-dialog persistent v-model="dialog_show" fullscreen width="80%">
        <v-card>
          <v-toolbar dense color="indigo" class="white--text">
            <v-toolbar-title>Pianificazione</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  @click="salvaPianificazione"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="success"> mdi-floppy </v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="dialog_show = false"
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  <v-icon color="error">mdi-keyboard-backspace </v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-toolbar>
          <v-row align="center" class="mt-1 px-2">
            <v-col cols="3"
              ><v-text-field
                v-model="sel_pianificazione.codice"
                label="Codice"
                placeholder="Codice"
              ></v-text-field
            ></v-col>
            <v-col cols="3">
              <v-autocomplete
                v-model="sel_pianificazione.id_tipo_manutenzione"
                :items="tipo_manutenzione_list"
                item-text="des"
                label="Tipo Manutenzione"
                placeholder="Tipo Manutenzione"
                required
                item-value="id_tabella"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="3"
              ><v-text-field
                v-model="sel_pianificazione.descrizione"
                label="Descrizione"
                placeholder="Descrizione"
              ></v-text-field
            ></v-col>
            <v-col cols="3">
              <v-menu
                ref="menu"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="sel_pianificazione.ora_manutenzione"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="sel_pianificazione.ora_manutenzione"
                    label="Ora manutenzione"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="menu2"
                  v-model="sel_pianificazione.ora_manutenzione"
                  full-width
                  @click:minute="
                    $refs.menu.save(sel_pianificazione.ora_manutenzione)
                  "
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col class="py-0" md="3" cols="3">
              <v-autocomplete
                v-model="sel_pianificazione.id_tipo_get_macchina"
                :items="tipo_macchina_list"
                item-text="des"
                label="Tipo"
                placeholder="des"
                required
                item-value="id_tabella"
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="3"
              ><v-checkbox
                v-model="sel_pianificazione.applica_intero_famiglia"
                label="Applica Tutta famiglia"
              ></v-checkbox
            ></v-col>
            <v-col class="py-0" cols="3" md="3">
              <v-autocomplete
                v-model="sel_pianificazione.id_sub_tipo_macchina"
                :disabled="
                  subtipoList.filter(
                    (elem) =>
                      elem.val_int === sel_pianificazione.id_tipo_get_macchina
                  ).length === 0
                "
                :items="
                  subtipoList.filter(
                    (el) =>
                      el.val_int === sel_pianificazione.id_tipo_get_macchina
                  )
                "
                label="Sub Tipo Macchina"
                placeholder="Sub Tipo Macchina"
                item-text="des"
                required
                item-value="id_tabella"
              >
                <template v-slot:append>
                  <v-icon
                    v-if="
                      sel_pianificazione.id_sub_tipo_macchina != null &&
                      sel_pianificazione.id_sub_tipo_macchina != '' &&
                      sel_pianificazione.id_sub_tipo_macchina != undefined
                    "
                    color="red"
                    @click="sel_pianificazione.id_sub_tipo_macchina = null"
                    >mdi-delete</v-icon
                  >
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="3"
              ><v-checkbox
                v-model="sel_pianificazione.applica_intero_sottofamiglia"
                label="Applica Tutta sottofamiglia"
              ></v-checkbox
            ></v-col>

            <v-col cols="3">
              <v-autocomplete
                v-model="sel_pianificazione.id_condizione"
                :items="condizione_list"
                item-text="des"
                label="Condizione"
                placeholder="Condizione"
                required
                item-value="id_tabella"
              >
                <!-- <template #label>
                  <span class="">Condizione</span>
                  <a @click.stop style="pointer-events: all">
                    <Modules
                      v-on:dialogModules="gettabelle"
                      tipo="CONDIZIONE"
                      nome="Condizione"
                      setaction="settabelle"
                      getaction="gettabelle"
                      controller="Magazzino"
                      filter="validita = 1"
                      :dati="[{ des: '' }]"
                    />
                  </a>
                </template> -->
              </v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                v-model="sel_pianificazione.id_frequenza"
                :items="frequenza_list"
                item-text="des"
                label="Tipo Frequenza"
                placeholder="Tipo Frequenza"
                required
                item-value="id_tabella"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="3"
              ><v-text-field
                v-model="sel_pianificazione.frequenza"
                label="Frequenza"
                placeholder="Frequenza"
                type="number"
                :min="0"
              ></v-text-field
            ></v-col>

            <v-col cols="3" lg="3" md="3" sm="3" class="py-0">
              <v-autocomplete
                v-model="sel_pianificazione.id_oggetto"
                :items="macchinaList"
                label="Oggetto"
                :item-text="
                  (item) => `${item.des_macchina} - ${item.cod_macchina}`
                "
                placeholder="Des. Oggetto"
                item-value="id_macchina"
                required
                @change="setValues"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                v-model="sel_pianificazione.id_azione"
                :items="azione_list"
                item-text="des"
                label="Azione"
                placeholder="des"
                required
                item-value="id_tabella"
              >
                <template #label>
                  <span class="">Azione</span>
                  <a @click.stop style="pointer-events: all">
                    <Modules
                      v-on:dialogModules="gettabelle"
                      tipo="AZIONE"
                      nome="Azione"
                      setaction="settabelle"
                      getaction="gettabelle"
                      controller="Magazzino"
                      filter="validita = 1"
                      :dati="[{ des: '' }]"
                    />
                  </a>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="9">
              <v-textarea
                v-model="sel_pianificazione.note"
                label="Note"
                placeholder="Note"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-card-subtitle>
            <v-tabs class="mt-5" v-model="tab_contenitore" align-with-title>
              <v-tabs-slider color="transparent"></v-tabs-slider>
              <v-tab
                active-class="py-0 my-0 indigo white--text"
                class="py-0 my-0"
                v-for="item in tabs_Interventi"
                :key="item"
              >
                {{ item }}
              </v-tab>
            </v-tabs>
          </v-card-subtitle>
          <v-card-text class="mt-4">
            <v-tabs-items v-model="tab_contenitore">
              <v-tab-item>
                <v-dialog v-model="avvisi_dialog">
                  <v-card>
                    <v-toolbar dense color="indigo" class="white--text">
                      <v-toolbar-title>Avvisi</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            @click="salvaAvvisi"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon color="success"> mdi-floppy </v-icon>
                          </v-btn>
                        </template>
                        <span>Aggiungi</span>
                      </v-tooltip>
                      <v-spacer></v-spacer>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="avvisi_dialog = false"
                            v-bind="attrs"
                            v-on="on"
                            small
                          >
                            <v-icon color="error">mdi-window-close </v-icon>
                          </v-btn>
                        </template>
                        <span>Close</span>
                      </v-tooltip>
                    </v-toolbar>
                    <v-card-text>
                      <v-autocomplete
                        v-model="avvisi_sel.id_persona"
                        :items="utenteList"
                        label="Persona"
                        placeholder="Persona"
                        item-text="nominativo"
                        item-value="id_personale"
                        required
                      >
                      </v-autocomplete>
                    </v-card-text>
                  </v-card>
                </v-dialog>
                <v-card>
                  <v-toolbar dense color="indigo" class="white--text">
                    <v-toolbar-title></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          @click="openAvviso"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="primary"> mdi-plus </v-icon>
                        </v-btn>
                      </template>
                      <span>Salva</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-row align="center">
                    <v-col cols="12">
                      <v-data-table
                        :items="DettaglioTabellaAvvisi"
                        :headers="DettaglioHeadersAvvisi"
                      >
                        <!-- Botton for updating Intervento -->

                        <template v-slot:[`item.email`]="{ item }">
                          <v-checkbox v-model="item.email"></v-checkbox>
                        </template>
                        <template v-slot:[`item.phone`]="{ item }">
                          <v-checkbox v-model="item.phone"></v-checkbox>
                        </template>
                        <template v-slot:[`item.telegram`]="{ item }">
                          <v-checkbox v-model="item.telegram"></v-checkbox>
                        </template>
                        <!-- Botton for deleting the Intervento -->
                        <template v-slot:[`item.delete`]="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="deleteAvvissi(item)"
                                small
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon color="error">
                                  mdi-window-close
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Elimina</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <GestioneAllegato
                  @click_chiudi="gestione_allegati_visible = false"
                  controller_allegati="Global"
                  controller_caratteristiche_tabella="Manutenzione"
                  :id_riferimento="sel_pianificazione.id_pianificazione"
                  :read_only="false"
                  ref="componenteAllegati"
                  :show_save_button="false"
                  @snackbarOpen="snackbarOpen"
                  tipo_allegato="QM_PIANIFICAZIONE"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Snackbar -->
      <SnackbarQV ref="SnackbarQV" />
    </v-card>
  </div>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

import moment from "moment";
import GestioneAllegato from "../../TOOLS/GestioneAllegato.vue";
class Pianificazione {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_pianificazione", default_val: -1 },
      { nome: "codice", default_val: "" },
      { nome: "descrizione", default_val: null },
      { nome: "applica_intero_famiglia", default_val: false },
      { nome: "applica_intero_sottofamiglia", default_val: false },
      { nome: "id_tipo_manutenzione", default_val: null },
      { nome: "id_oggetto", default_val: null },
      { nome: "id_tipo_get_macchina", default_val: null },
      { nome: "id_sub_tipo_macchina", default_val: null },
      { nome: "ora_manutenzione", default_val: "" },
      { nome: "id_frequenza", default_val: "" },
      { nome: "frequenza", default_val: 0 },
      { nome: "id_condizione", default_val: "" },
      { nome: "des_condizione", default_val: "" },
      { nome: "id_azione", default_val: "" },
      { nome: "note", default_val: "" },
      { nome: "validita", default_val: 1 },
      { nome: "avvisi", default_val: [] },
    ];

    return campi;
  }
}

class Avviso {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_pianificazione", default_val: -1 },
      { nome: "id_painificazione_avvisi", default_val: -1 },
      { nome: "email", default_val: 0 },
      { nome: "id_persona", default_val: null },
      { nome: "des_persona", default_val: null },
      { nome: "phone", default_val: 0 },
      { nome: "telegram", default_val: 0 },
      { nome: "id_temp", default_val: -1 },
      { nome: "validita", default_val: 1 },
      { nome: "id_utente", default_val: null },
      // { nome: "data_ins", default_val: null },
      // { nome: "data_mod", default_val: "" },
    ];

    return campi;
  }
}
export default {
  name: "",
  components: {
    SnackbarQV,
    GestioneAllegato,
    Modules: () => import("@/components/TOOLS/Modules"),
  },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      sel_pianificazione: new Pianificazione(),
      codice_search: "",
      tipo_search: "",
      oggetto_search: "",
      sub_tipo_search: "",
      tipo_manu_search: "",
      sottofamiglia_search: "",
      famiglia_search: "",
      condizione_search: "",
      date: "",
      persona: "",
      avvisi_sel: new Avviso(),
      // Modal
      menu2: false,
      show_filtri: false,
      dialog_add: false,
      dialog_show: false,
      avvisi_dialog: false,
      loading: false,
      loadingAvvisi: false,
      // Array
      tab_contenitore: [],
      lista_etichette: [],
      azione_list: [],
      lista_tabella: [],
      deletedAvvissi: [],
      tipo_manutenzione_list: [],
      tipo_macchina_list: [],
      subtipoList: [],
      macchinaList: [],
      items_pezzi_visualizzati: [],
      condizione_list: [],
      utenteList: [],
      frequenza_list: [
        {
          des: "ora",
          id_tabella: 1,
        },
        {
          des: "giorno",
          id_tabella: 2,
        },
        {
          des: "mese",
          id_tabella: 3,
        },
        {
          des: "anno",
          id_tabella: 4,
        },
      ],
      headers_etichette: [
        {
          text: "",
          value: "edit",
          sortable: false,
        },
        {
          text: "Codice",
          value: "codice",
          sortable: true,
        },
        {
          text: "Tipo",
          value: "des_tipo",
          sortable: true,
        },
        {
          text: "Sub Tipo",
          value: "des_sub_tipo",
          sortable: true,
        },
        {
          text: "Oggetto",
          value: "des_oggetto",
          sortable: true,
        },
        {
          text: "Tipo Manu.",
          value: "des_tipo_manu",
          sortable: true,
        },
        {
          text: "Condizione",
          value: "des_condizione",
          sortable: true,
        },
        {
          text: "Intero famiglia",
          value: "applica_intero_famiglia",
          sortable: true,
        },
        {
          text: "Intero sottofamiglia",
          value: "applica_intero_sottofamiglia",
          sortable: true,
        },

        {
          text: "",
          value: "delete",
          sortable: false,
        },
      ],
      tabs_Interventi: ["Avvisi", "Allegati"],

      DettaglioHeadersAvvisi: [
        {
          text: "",
          value: "edit",
          sortable: false,
        },
        {
          text: "Persona",
          value: "des_persona",
          sortable: true,
        },
        {
          text: "Mail",
          value: "email",
          sortable: true,
        },
        {
          text: "Sms",
          value: "phone",
          sortable: true,
        },
        {
          text: "Telegram",
          value: "telegram",
          sortable: true,
        },
        {
          text: "",
          value: "delete",
          sortable: false,
        },
      ],
      DettaglioTabellaAvvisi: [],
    };
  },
  methods: {
    setValues() {
      let i = this.macchinaList.findIndex(
        (it) => it.id_macchina === this.sel_pianificazione.id_oggetto
      );
      this.sel_pianificazione.id_tipo_get_macchina =
        this.macchinaList[i].id_tipo_get_macchina;
      this.sel_pianificazione.id_sub_tipo_macchina =
        this.macchinaList[i].id_sub_tipo_macchina;
    },
    activateFilters() {
      if (this.show_filtri) {
        this.show_filtri = false;

        this.resetFiltro();
      } else {
        this.show_filtri = true;
      }
    },
    gettabelle() {
      // TO populate the list of select fields
      let req_data = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "'INTERVENTI_AZIONE','TIPO_MANUTENZIONE','TIPO_GET_MACCHINA','SUB_TIPO_MACCHINA','CONDIZIONE'",
          filter: "validita = 1",
        },
      };
      this.$store.dispatch("api", req_data).then((res) => {
        this.azione_list = res.data.INTERVENTI_AZIONE;
        this.tipo_manutenzione_list = res.data.TIPO_MANUTENZIONE;
        this.tipo_macchina_list = res.data.TIPO_GET_MACCHINA;
        this.subtipoList = res.data.SUB_TIPO_MACCHINA;
        this.condizione_list = res.data.CONDIZIONE;
      });
    },
    openAvviso() {
      this.avvisi_dialog = true;
      this.avvisi_sel = new Avviso();
    },
    snackbarOpen() {
      this.$refs.SnackbarQV.print(
        "orange",
        `Aggiungere ad ogni Allegato dell'attività una descrizione.`
      );
    },
    openformDialog() {
      this.sel_pianificazione = new Pianificazione();
      this.DettaglioTabellaAvvisi = [];
      this.dialog_show = true;
      this.$refs.componenteAllegati.lista_allegati = [];
    },
    updatePianificazione(item) {
      this.sel_pianificazione = new Pianificazione(item);
       this.sel_pianificazione.applica_intero_famiglia =  this.sel_pianificazione.applica_intero_famiglia === 'si' ? true : false;
      this.sel_pianificazione.applica_intero_sottofamiglia = this.sel_pianificazione.applica_intero_sottofamiglia === 'si' ? true : false;
      this.dialog_show = true;
      this.loadingAvvisi = true;
      const request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getpianificazionedetail",
          token: localStorage.user_token,
          id_pianificazione: this.sel_pianificazione.id_pianificazione,
        },
      };
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.DettaglioTabellaAvvisi =
              res.data.pianificazione.avvisi.reverse();
            this.loadingAvvisi = false;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, codice stato: ${res.status}.`
            );
            this.loadingAvvisi = false;
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    salvaPianificazione() {
      if (
        this.sel_pianificazione.codice === null ||
        this.sel_pianificazione.codice === ""
      ) {
        this.$refs.SnackbarQV.print("orange", `il Codice è vuoto`);
        return;
      }
      this.sel_pianificazione.avvisi = this.DettaglioTabellaAvvisi;
      this.sel_pianificazione.id_utente = localStorage.id;
      this.sel_pianificazione.applica_intero_famiglia =
        this.sel_pianificazione.applica_intero_famiglia === false ? 0 : 1;
      this.sel_pianificazione.applica_intero_sottofamiglia =
        this.sel_pianificazione.applica_intero_sottofamiglia === false ? 0 : 1;
      if (this.deletedAvvissi.length > 0) {
        this.deletedAvvissi.map((it) => {
          this.sel_pianificazione.avvisi.push(it);
        });
      }
      const request = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          action: "setpianificazione",
          token: localStorage.user_token,
          id_pianificazione: this.sel_pianificazione.id_pianificazione,
          data: [this.sel_pianificazione],
          delete: "",
        },
      };

      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          if (res.status === 200) {
            if (this.$refs.componenteAllegati) {
              this.$refs.componenteAllegati.id_riferimento_creazione_genitore =
                res.data.result.split(",")[1];
              let resSalvataggio =
                await this.$refs.componenteAllegati.salvaTuttiAllegati();

              if (resSalvataggio) {
                this.$refs.SnackbarQV.print(
                  "success",
                  `Salvataggio avvenuto con successo`
                );

                this.$refs.componenteAllegati.lista_allegati = [];
              } else {
                this.$refs.SnackbarQV.print(
                  "orange",
                  `Aggiungere una descrizione per ogni Allegato.`
                );
              }
            }
            this.getPianificazione();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, codice stato: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
      this.dialog_show = false;
      this.sel_pianificazione.id_pianificazione = -1;
    },

    deletePianificazione(item) {
      let data = item;
      item.id_utente = localStorage.id;
      data.validita = 0;
      const request = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          action: "setpianificazione",
          token: localStorage.user_token,
          id_pianificazione: item.id_pianificazione,
          data: [data],
          delete: "1",
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.getPianificazione();
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Criticità rilevata, codice stato: ${res.status}.`
          );
          this.loading = false;
        }
      });
      let i = this.lista_tabella.indexOf(item);
      this.lista_tabella.splice(i, 1);
    },
    salvaAvvisi() {
      let data = this.avvisi_sel;
      if (data.id_persona === null || data.id_persona === "") {
        this.$refs.SnackbarQV.print("orange", `il Nome è vuoto`);
        return;
      }
      data.id_utente = localStorage.id;
      let i = this.utenteList.findIndex(
        (it) => it.id_personale == this.avvisi_sel.id_persona
      );
      data.des_persona = this.utenteList[i].nominativo;
      data.id_pianificazione =
        this.sel_pianificazione.id_pianificazione !== -1
          ? this.sel_pianificazione.id_pianificazione
          : -1;
      if (data.id_temp === -1) {
        data.id_temp = moment().unix();
        this.DettaglioTabellaAvvisi.push(data);
      } else {
        let i = this.DettaglioTabellaAvvisi.findIndex(
          (it) => this.avvisi_sel.id_temp == it.id_temp
        );
        this.DettaglioTabellaAvvisi.splice(i, 1, this.avvisi_sel);
      }

      this.avvisi_dialog = false;
    },
    deleteAvvissi(item) {
      if (item.id_temp > -1) {
        item.validita = 0;
        this.deletedAvvissi.push(item);
      }
      let i = this.DettaglioTabellaAvvisi.indexOf(item);
      this.DettaglioTabellaAvvisi.splice(i, 1);
    },
    getPianificazione() {
      this.loading = true;
      const request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getpianificazione",
          token: localStorage.user_token,
          id_pianificazione: "",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.lista_etichette = res.data.pianificazione.Table1;
            this.lista_tabella = this.lista_etichette.reverse();

            this.items_pezzi_visualizzati = this.lista_tabella;
            for (
              let index = 0;
              index < this.items_pezzi_visualizzati.length;
              index++
            ) {
              const element = this.items_pezzi_visualizzati[index];
              element.applica_intero_famiglia =
                element.applica_intero_famiglia == 0 ? "no" : "si";
              element.applica_intero_sottofamiglia =
                element.applica_intero_sottofamiglia == 0 ? "no" : "si";
            }
            this.loading = false;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, codice stato: ${res.status}.`
            );
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    goBack() {
      this.$router.push("/home/quickmaintenance");
    },
    goToDetail(item) {
      this.$emit(
        "goToDetail",
        [this.obj_label],
        item.modello_report,
        item.id_articolo_packaging_report
      );
    },
    filtra() {
      let items_etichette_tmp = [];
      this.lista_etichette.forEach((elem) => {
        items_etichette_tmp.push(elem);
      });

      // Filtro il nome della intervento
      if (this.codice_search != "" && this.codice_search != null) {
        // Faccio un array temporaneo
        const res = [];
        if (this.codice_search == "*") {
          this.lista_tabella = this.lista_etichette;
          return;
        }
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.filter((elem) => {
          if (
            elem.codice.toLowerCase().includes(this.codice_search.toLowerCase())
          ) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      if (this.tipo_search != "" && this.tipo_search != null) {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.filter((elem) => {
          if (
            elem.des_tipo.toLowerCase().includes(this.tipo_search.toLowerCase())
          ) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }
      if (this.sub_tipo_search != "" && this.sub_tipo_search != null) {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.filter((elem) => {
          if (
            elem.des_sub_tipo
              .toLowerCase()
              .includes(this.sub_tipo_search.toLowerCase())
          ) {
            res.push(elem);
          }
        });

        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      if (this.oggetto_search != "" && this.oggetto_search != null) {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (elem.des_oggetto == this.oggetto_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }
      if (this.tipo_manu_search != "" && this.tipo_manu_search != null) {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (elem.des_tipo_manu == this.tipo_manu_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      if (this.condizione_search != "" && this.condizione_search != null) {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (elem.des_condizione == this.condizione_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }
      if (this.famiglia_search != null && this.famiglia_search !== "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (elem.applica_intero_famiglia == this.famiglia_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }
      if (
        this.sottofamiglia_search !== "" &&
        this.sottofamiglia_search != null
      ) {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (elem.applica_intero_sottofamiglia == this.sottofamiglia_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      this.lista_tabella = items_etichette_tmp;
    },
    resetTable() {
      this.codice_search = "";
      this.famiglia_search = "";
      this.sottofamiglia_search = "";
      this.oggetto_search = "";
      this.tipo_search = "";
      this.sottofamiglia_search = "";
      this.famiglia_search = "";
      this.condizione_search = "";
      this.lista_tabella = this.lista_etichette;
    },
    resetFiltro() {
      // Resetto i filtri
      this.codice_search = "";
      this.tipo_search = "";
      this.sub_tipo_search = "";
      this.oggetto_search = "";
      this.tipo_manu_search = "";
      this.sottofamiglia_search = "";
      this.famiglia_search = "";
      this.condizione_search = "";
      // Nascondo i filtri
      this.show_filtri = false;

      this.lista_tabella = this.lista_etichette;
    },
  },
  created() {},
  computed: {
    formatDate() {
      return this.date ? moment(this.date).format("DD/MM/YYYY") : "";
    },
  },
  mounted() {
    this.getPianificazione();
    this.lista_etichette = this.lista_tabella;
    this.lista_tabella = this.lista_etichette;

    this.gettabelle();
    let manu_detail = {
      controller: "Manutenzione",
      method: "POST",
      richiesta: {
        action: "getlistamacchine",
        token: localStorage.getItem("user_token"),
      },
    };
    this.$store.dispatch("api", manu_detail).then((res) => {
      let macchinaData = res.data.macchine;
      macchinaData.filter((it) => {
        const updateobject = {};
        updateobject.id_macchina = it.id_macchina;
        updateobject.des_macchina = it.des_macchina;
        updateobject.cod_macchina = it.cod_macchina;
        updateobject.id_tipo_get_macchina = it.id_tipo_get_macchina;
        updateobject.id_sub_tipo_macchina = it.id_sub_tipo_macchina;
        this.macchinaList.push(updateobject);
        return this.macchinaList;
      });
    });
    let getUtenteList = {
      controller: "Magazzino",
      method: "POST",
      richiesta: {
        action: "getutenti",
        token: localStorage.getItem("user_token"),
      },
    };
    this.$store.dispatch("api", getUtenteList).then((res) => {
      this.utenteList = res.data;
    });
  },
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
    date(val) {
      let value = moment(val, "YYYY-MM-DD").format("DD/MM/YYYY");

      if (val !== "") {
        let items_etichette_tmp = [];
        this.lista_etichette.forEach((elem) => {
          items_etichette_tmp.push(elem);
        });

        // Faccio un array temporaneo

        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.filter((elem) => {
          if (elem.consegna == value) {
            res.push(elem);
          }
        });

        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
        this.lista_tabella = items_etichette_tmp;
      }
    },
  },
};
</script>
<style scoped>
</style>